import { render, staticRenderFns } from "./AccUpgrade.vue?vue&type=template&id=e04ecb10&"
import script from "./AccUpgrade.vue?vue&type=script&lang=js&"
export * from "./AccUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports